import { defineMessages } from 'react-intl';

export default defineMessages({
  successButtonTitle: 'See proposal',
  connectWallet: 'Please connect a wallet',
  connectWalletDescription: 'We couldn’t detect a wallet. Connect a wallet to vote.',
});
